/* eslint-disable import/no-unused-modules */
import { PaymentTermsResponse } from "features/cancellation-policy/useRemotePaymentTerms";
import {
  CruiseGroupPaymentTerms,
  CruiseGroupV2ApiResponse
} from "@silversea-ssc/dotcom-api-types/CruiseGroup";
import { UseFetchDataResponse } from "src/ssc-api/useFetchApi";
import { FareCode } from "@silversea-ssc/web-fares";
import { isPresent } from "src/utils/checks";
import { CancellationPolicyModalContentFragment } from "types/graphql-types";
import { CancellationPolicyModalContent } from "@silversea-ssc/system-components-react/cancellation-policy-modal";

export type PaymentTerms =
  | PaymentTermsResponse
  | RemotePaymentTermFareResponse<CruiseGroupPaymentTerms>;

export type RemotePaymentTermFareResponse<T> = T & { fareCode: FareCode };

export const fromCruiseGroupV2ApiResponse = (
  response: UseFetchDataResponse<CruiseGroupV2ApiResponse>
): RemotePaymentTermFareResponse<CruiseGroupPaymentTerms>[] =>
  (
    response.data?.fares.map((f) => {
      if (!f.paymentTerms) return undefined;
      return {
        ...f.paymentTerms,
        fareCode: f.fareCode
      };
    }) || []
  ).filter(isPresent);

export const toCancellationPolicyModalContent = (
  content: CancellationPolicyModalContentFragment
): CancellationPolicyModalContent => {
  return {
    ...content,
    cancelledBy: (content.cancelledBy || []).filter(isPresent).map((x) => ({
      ...x,
      title: x?.title?.localized,
      content: x.content?.localized,
      staticInfographicRefundableLabel:
        x.staticInfographicRefundableLabel?.localized,
      staticInfographicFCCNote: x.staticInfographicFCCNote?.localized,
      disclaimer: x.disclaimer?.localized
    }))
  };
};
